import { createContext } from 'react'

/**
 * Context for extended firebase instance created
 * by react-redux-firebase
 */
const ReduxFirestoreContext = createContext(null)

export default ReduxFirestoreContext
